import React from 'react';
import { Field, ErrorMessage, useFormikContext } from 'formik';
import { settlementAgreement } from '../../../constants/formFields/settlementAgreement';
import { whatIsYourObjective } from '../../../constants/formFields/whatIsYourObjective';

export const StepFour = () => {
  const { values } = useFormikContext();
  return (
    <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step4">
      {/* <h6 className="text-lg font-bold mb-6">Agreement and Intentions</h6> */}

      <div className="mb-6 form-radio2-main">
        <label htmlFor="settlement-agreement" className="block text-gray-700 font-medium mb-2">
          Do you have a settlement agreement document?
        </label>
        <div className="space-y-2">
          {settlementAgreement.map((ele, i) => {
            const id = `settlement_agreement_${i}`;
            return (
              <div className="flex items-center form-radio2" key={i}>
                <Field
                  type="radio"
                  id={id}
                  name="settlement-agreement"
                  value={ele.value}
                  className="mr-2"
                />
                <label htmlFor={id}>{ele.label}</label>
              </div>
            );
          })}
          <ErrorMessage name="settlement-agreement" component="div" className="required-text" />
        </div>
      </div>

      {values['still-employed'] === 'E' && (
        <div className="mb-6 form-radio2-main">
          <label className="block text-gray-700 font-medium mb-2">
            Do you want to leave your job?
          </label>
          <div className="space-y-2">
            {whatIsYourObjective.map((ele, i) => {
              const id = `what_is_your_objective_${i}`;
              return (
              <div className="flex items-center form-radio2" key={i}>
                <Field
                  type="radio"
                  id={id}
                  name="what-is-your-objective"
                  value={ele.value}
                  className="mr-2"
                />
                <label htmlFor={id}>{ele.label}</label>
              </div>
            )})}
            <ErrorMessage name="what-is-your-objective" component="div" className="required-text" />
          </div>
        </div>
      )}
    </div>
  );
};
